import React from 'react';
import { Helmet } from 'react-helmet-async';
import SettingsView from '../../../components/settings/common/SettingsPage';



const AdminSettingsView = () => {


  return (
    <React.StrictMode>
      <Helmet>
        <title>Admin Settings</title>
      </Helmet>
      <SettingsView rootURL={'/app/admin'} label="Admin Settings" />

    </React.StrictMode>
  )
};

export default AdminSettingsView;
